import axios from '@/libs/api.request'

// 登录
export const apiLogin = data => {
  return axios.request({
    url: '/admin/login',
    method: 'post',
    data,
  })
}

// 退出
export const apiLogout = data => {
  return axios.request({
    url: '/admin/logout',
    method: 'get',
    data,
  })
}

// 用户列表
export const apiUser = data => {
  return axios.request({
    url: '/admin/users',
    method: 'get',
    data,
  })
}
